module.exports = __webpack_public_path__ + "static/media/bushu-07.429be5fb.png";